import axios from 'axios'
import {useMutation} from '@tanstack/react-query'
import {ApiUrls} from "../config/urls";
import {useAuth} from "../context/auth-context";

export default function usePostTopoValidation(language) {
    const auth = useAuth();

    return useMutation({
            networkMode: 'always',
            mutationFn: (values) => axios.post(ApiUrls.VALIDATION.replace('{lng}', language), values)
                .then((res) => {
                    if (res.data.success === true) {
                        return res.data.data;
                    } else {
                        return res.data;
                    }
                })
            ,

            onError: (error, _updateStoreRoute, rollback) => {
                console.log(error);
                if (rollback) rollback()
            },
            onSuccess: (data) => {
                auth.clearReactQueryCache();
            }
        }
    );
}
